import classNames from 'classnames/bind';
import { useRef, useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export function useToast(): [
  string | undefined,
  (text: string, duration?: number) => void,
] {
  const timeoutId = useRef<number>();
  const [message, setMessage] = useState<string>();

  function showToast(text: string, duration: number = 2) {
    if (timeoutId.current) window.clearTimeout(timeoutId.current);
    setMessage(text);
    timeoutId.current = window.setTimeout(() => {
      setMessage(undefined);
      timeoutId.current = undefined;
    }, duration * 1000);
  }

  return [message, showToast];
}

export default function Toast({ message }: { message?: string }) {
  if (!message) return null;
  return (
    <div className={cx('Toast')} role="alert">
      <p className={cx('toast_message_txt')}>{message}</p>
    </div>
  );
}
